import React from "react";
import "../style.css";

const KrytyPage: React.FC = () => {
  return (
    <body
      style={{
        fontFamily: '"Montserrat", sans-serif',
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        zIndex: 10000,
      }}
    >
      <div className="kryte-bg">
        <div className="head">
          <div>
            <img className="logo2" src={`${process.env.PUBLIC_URL}/img/rcs.png`} />
          </div>
          <h1 style={{ color: "#2097db", fontWeight: 800 }}>BASENY KRYTE</h1>
        </div>
        <p className="txt">
          Sprzedaż internetowa biletów na baseny kryte jest niedostępna. Do zakupu biletów zapraszamy na obiekty.
        </p>

        <p style={{ color: "#2097db", fontWeight: 800, fontSize: 18 }}>Basen Centrum 7</p>
        <p className="txt">ul. Sybiraków 11, 59-300 Lubin, tel. 76 746 56 10</p>

        <p className="txt">
          Więcej informacji na stronie:{" "}
          <a href="http://rcslubin.pl/obiekty/basen-kryty-centrum">http://rcslubin.pl/obiekty/basen-kryty-centrum</a>
        </p>
        <p></p>
        <p></p>
        <p style={{ color: "#2097db", fontWeight: 800, fontSize: 18, marginTop: 30 }}>Basen Ustronie</p>
        <p className="txt">ul. Marii Konopnickiej 5, 59-300 Lubin, tel.. 76 846 08 27</p>

        <p></p>
        <p className="txt">
          Więcej informacji na stronie:{" "}
          <a href="http://rcslubin.pl/obiekty/basen-kryty-ustronie">http://rcslubin.pl/obiekty/basen-kryty-ustronie</a>
        </p>
      </div>
    </body>
  );
};

export default KrytyPage;
